import Vue from 'vue'
import VueSuggestion from 'vue-suggestion'

Vue.use(VueSuggestion)
